// removed by extract-text-webpack-plugin
module.exports = {"body":"app-pages-Library-Modifier-Detail-ModifierForm-ModifierOptionsModal-__ModifierOptionsModal___1GWgl","dialog":"app-pages-Library-Modifier-Detail-ModifierForm-ModifierOptionsModal-__ModifierOptionsModal___27b2a"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Modifier/Detail/ModifierForm/ModifierOptionsModal/ModifierOptionsModal.css
// module id = 2190
// module chunks = 0